export const FETCH_OVERVIEW_REQUEST = "FETCH_OVERVIEW_REQUEST";
export const FETCH_OVERVIEW_SUCCESS = "FETCH_OVERVIEW_SUCCESS";
export const DISPLAY_ERROR_MESSAGE = "DISPLAY_ERROR_MESSAGE";
export const SET_FROM_DATE = "SET_FROM_DATE";
export const SET_UNTIL_DATE = "SET_UNTIL_DATE";
export const FETCH_DATE_CONFIG = "FETCH_DATE_CONFIG";
export const RESET_MODEL_AND_ERROR_FLAGS = "RESET_MODEL_AND_ERROR_FLAGS";
export const SET_LOADING_FALSE = "SET_LOADING_FALSE";
export const SET_OVERVIEW_DATA = "SET_OVERVIEW_DATA";
export const SET_IS_VALID_DATERANGE = "SET_IS_VALID_DATERANGE";
export const IS_OVERVIEW_FILTER_APPLIED = "IS_OVERVIEW_FILTER_APPLIED";
export const CLEAR_OVERVIEW_FILTER = "CLEAR_OVERVIEW_FILTER";
export const SET_OVERVIEW_FILTER_DATA = "SET_OVERVIEW_FILTER_DATA";
